import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import auth from "./auth";
import users from "./users";
import settings from "./settings";
import categories from "./categories";
import vehicules from "./vehicules";
import items from "./items";
import notes from "./notes";
import events from "./events";
import tools from "./tools";
import drop from "./drop";
import closings from "./closings";
import employees from "./employees";
import rent from "./rent";
import payments from "./payments";
import crash from "./crash";
import payroll from "./payroll";
import misions from "./misions";
import runner from "./runner";
import spent from "./spent";

export default new Vuex.Store({
  modules: [
    auth,
    users,
    settings,
    categories,
    vehicules,
    items,
    notes,
    events,
    tools,
    drop,
    closings,
    employees,
    rent,
    payments,
    crash,
    payroll,
    misions,
    runner,
    spent
  ],
});
